import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { AlertTriangle } from 'lucide-react';

const formatNumber = (num) => new Intl.NumberFormat('es-CL').format(num || 0);

export const PresupuestoCard = ({
  presupuesto,
  handlePresupuestoChange,
  handleKeyDown,
  inputRefs,
  presupuestoMismatch,
  monto,
  totalPresupuesto,
}) => (
  <Card>
    <CardHeader className="py-4">
      <CardTitle className="font-heading text-lg">Presupuesto</CardTitle>
      <p className="text-sm text-muted-foreground">Presione Enter para pasar al siguiente campo</p>
    </CardHeader>
    <CardContent>
      <div className="max-w-md space-y-3">
        <div className="grid grid-cols-2 gap-4 items-center">
          <Label>Prespto. Materiales</Label>
          <Input ref={inputRefs.materiales} type="number" value={presupuesto.materiales || ''} onChange={(e) => handlePresupuestoChange('materiales', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'materiales')} placeholder="0" className="text-right font-mono" data-testid="input-presupuesto-materiales" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center">
          <Label>Prespto. SS.TT.</Label>
          <Input ref={inputRefs.servicios_terceros} type="number" value={presupuesto.servicios_terceros || ''} onChange={(e) => handlePresupuestoChange('servicios_terceros', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'servicios_terceros')} placeholder="0" className="text-right font-mono" data-testid="input-presupuesto-sstt" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center">
          <Label>Valor HH</Label>
          <Input ref={inputRefs.valor_hh} type="number" value={presupuesto.valor_hh || ''} onChange={(e) => handlePresupuestoChange('valor_hh', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'valor_hh')} placeholder="12500" className="text-right font-mono" data-testid="input-presupuesto-valor-hh" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center">
          <Label>N° H.H.</Label>
          <Input ref={inputRefs.numero_hh} type="number" value={presupuesto.numero_hh || ''} onChange={(e) => handlePresupuestoChange('numero_hh', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'numero_hh')} placeholder="0" className="text-right font-mono" data-testid="input-presupuesto-numero-hh" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center bg-muted/50 p-2 rounded">
          <Label>Prespto. Mano Obra</Label>
          <Input type="text" value={`$ ${formatNumber(presupuesto.mano_obra)}`} disabled className="text-right font-mono bg-transparent border-0" data-testid="display-presupuesto-mano-obra" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center">
          <Label>Gastos Generales</Label>
          <Input ref={inputRefs.gastos_generales} type="number" value={presupuesto.gastos_generales || ''} onChange={(e) => handlePresupuestoChange('gastos_generales', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'gastos_generales')} placeholder="0" className="text-right font-mono" data-testid="input-presupuesto-gastos-generales" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center">
          <Label>Utilidad</Label>
          <Input ref={inputRefs.utilidad} type="number" value={presupuesto.utilidad || ''} onChange={(e) => handlePresupuestoChange('utilidad', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'utilidad')} placeholder="0" className="text-right font-mono" data-testid="input-presupuesto-utilidad" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center border-t-2 pt-3">
          <Label className="font-bold text-base">Total Presupuesto</Label>
          <Input type="text" value={`$ ${formatNumber(presupuesto.total)}`} disabled className={`text-right font-mono font-bold text-base ${presupuestoMismatch ? 'bg-destructive/10 text-destructive' : 'bg-primary/10'}`} data-testid="display-presupuesto-total" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center">
          <Label>Kilos</Label>
          <Input ref={inputRefs.kilos} type="number" value={presupuesto.kilos || ''} onChange={(e) => handlePresupuestoChange('kilos', e.target.value)} onKeyDown={(e) => handleKeyDown(e, 'kilos')} placeholder="0" className="text-right font-mono" data-testid="input-presupuesto-kilos" />
        </div>
      </div>

      {presupuestoMismatch && (
        <div className="mt-4 p-3 bg-destructive/10 border border-destructive/30 rounded-lg flex items-start gap-3" data-testid="presupuesto-mismatch-alert">
          <AlertTriangle className="w-5 h-5 text-destructive flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="font-medium text-destructive">El Monto no coincide con el Total Presupuesto</p>
            <p className="text-muted-foreground">Monto: $ {formatNumber(monto)} | Total: $ {formatNumber(totalPresupuesto)} | Diferencia: $ {formatNumber(Math.abs(monto - totalPresupuesto))}</p>
          </div>
        </div>
      )}
    </CardContent>
  </Card>
);
